import React from "react";
import { useToastContext } from "../../context/ToastContext";
import MessageToast from "./MessageToast";

const GlobalToast: React.FC = () => {
  const { toast, closeToast } = useToastContext();

  if (!toast) return null;

  return (
    <MessageToast
      type={toast.type}
      message={toast.message}
      onClose={closeToast}
    />
  );
};

export default GlobalToast;
